import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LoaderModule } from './modules';
import { AuthInterceptor } from './modules/auth.interceptor';
import {
  DashboardService,
  EncryptService,
  ProfileService,
  PublicDataService,
  SeoService,
} from './services';
import { UsersService } from './services/users/users.service';

const SERVICES = [
  PublicDataService,
  SeoService,
  EncryptService,
  DashboardService,
  ProfileService,
  UsersService,
];

@NgModule({
  imports: [CommonModule, LoaderModule.forRoot()],
  exports: [LoaderModule],
  providers: [
    SERVICES,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {}
